import React from "react";

import { AuthenticatedLayout } from "../../layoutsHOC/AuthenticatedLayout";

import { ReactComponent as EmojiSilence } from "../../assets/EmojiSilence.svg";

import "./Guidelines.css";
import { Header } from "../Settings/components/Header";

function GuidelinesPatientPrivacyInner() {
  return (
    <div style={{ maxWidth: "720px", width: "100%" }}>
      <Header title={"Community Guidelines"} showTitle={false} />
      <div className="flex flex-col pt-4 pb-4 gap-4 pl-4 pr-4">
        <EmojiSilence width={40} height={40} />
        <span className="GuidelinesTitle">Respect Patient Privacy</span>
        <span className="GuidelinesSubTitle">
          Personal Health Information (PHI):{" "}
        </span>
        <span className="GuidelinesDescription">
          In our community, we hold patient privacy very close to our hearts. We
          absolutely insist on keeping personal health information (PHI) that
          could identify a patient confidential.
        </span>
        <span className="GuidelinesDescription">
          This means that names, addresses, contact details, medical records,
          treatment details, etc. must not be shared. If you're sharing
          scenarios or discussions, please make sure they're fully anonymized
          and can't be traced back to anyone.
        </span>
        <span className="GuidelinesDescription">
          Safeguarding patient privacy isn't just about trust and respect—it's
          also about meeting legal and ethical standards. We appreciate your
          understanding and cooperation!
        </span>
      </div>
    </div>
  );
}

export default function GuidelinesPatientPrivacy(props) {
  return (
    <AuthenticatedLayout
      {...props}
      backgroundColor="#FBFDFE"
      hideHeader={true}
      hideFooter={true}
    >
      <GuidelinesPatientPrivacyInner {...props} />
    </AuthenticatedLayout>
  );
}
